import { ContextMenuContext } from '@components/organisms/navbar/ContextMenuContext';
import { useProfile } from '@hooks/api';
import { useLoadingModal } from '@hooks/useLoadingModal';
import { ChevronUpIcon, ProfileIcon } from '@moreharvest/component-library';
import { FormattedMessage } from '@utils/i18n';
import { ProfileResponse } from 'mh-client';
import { useCallback, useContext } from 'react';

const ContextMenuTitle = () => {
    const { isOpen: isContextMenuOpen } = useContext(ContextMenuContext);
    const { data: userProfile, isLoading } = useProfile();

    useLoadingModal(isLoading);

    const renderLoggedStatus = useCallback((userProfile: ProfileResponse) => {
        switch (userProfile.accountStatus?.name) {
            case 'Complete':
                return (
                    <VerifiedUserName
                        firstName={userProfile.firstName ?? undefined}
                        lastName={userProfile.lastName ?? undefined}
                    />
                );
            case 'None':
            case 'KycVerified':
            default:
                return (
                    <UnverifiedUserName
                        email={userProfile.email ?? undefined}
                    />
                );
        }
    }, []);

    return userProfile ? (
        <div className="flex items-center gap-x-2 font-semibold lg:font-normal Label-Large">
            <ProfileIcon className="hidden lg:block w-6 h-6 fill-neutral-800 dark:fill-neutral-800-dark" />
            {renderLoggedStatus(userProfile)}
            <ChevronUpIcon
                className="hidden lg:block w-4 h-4 fill-neutral-800 dark:fill-neutral-800-dark transition-transform"
                style={{
                    transform: isContextMenuOpen
                        ? 'rotate(0deg)'
                        : 'rotate(180deg)',
                }}
            />
        </div>
    ) : (
        <></>
    );
};

export const VerifiedUserName = ({
    firstName,
    lastName,
}: {
    firstName?: string;
    lastName?: string;
}) => {
    if (!firstName || !lastName) return null;

    return (
        <>
            <span className="hidden lg:block">
                {`${firstName} ${lastName}`}
            </span>
            <span className="block lg:hidden">
                Logged in as {`${firstName} ${lastName}`}
            </span>
        </>
    );
};

export const UnverifiedUserName = ({ email }: { email?: string }) => {
    if (!email) return null;

    return (
        <>
            <span className="hidden lg:block max-w-[15ch] overflow-clip text-ellipsis">{`${email}`}</span>
            <span className="block lg:hidden">
                <FormattedMessage
                    id="hamburger_log_in_as"
                    values={{ 0: email }}
                />
            </span>
        </>
    );
};

export default ContextMenuTitle;
